var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaQsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM9.86667 10.4C9.86667 9.22179 10.8218 8.26667 12 8.26667H12.64C13.7593 8.26667 14.6667 9.17404 14.6667 10.2933V10.4C14.6667 11.5782 13.7115 12.5333 12.5333 12.5333V13.6H11.4667V11.4667H12.5333C13.1224 11.4667 13.6 10.9891 13.6 10.4V10.2933C13.6 9.76314 13.1702 9.33333 12.64 9.33333H12C11.4109 9.33333 10.9333 9.8109 10.9333 10.4H9.86667ZM11.4667 15.7333V14.6667H12.5333V15.7333H11.4667Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQsIcon);
export default __webpack_public_path__ + "static/media/FAQsIcon.94a367bfdd07751f61f3f3e8605f870d.svg";
export { ForwardRef as ReactComponent };